import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';

import { stateOptions } from '../../../data/OptionValues';

const StateSelect = (props) => {

  const [install_state, setState] = useState(props.install_state);

  const handleStateChanged = (event) => {
    setState(event.target.value);
    if (props.onChange) {
      props.onChange({"install_state": event.target.value});
    } else {
      console.error("State changed handler not defined");
    }
  };

  useEffect(() => {
    setState(props.install_state);
  }, [props.install_state]);

  return (
    <TextField 
      select
      onChange={handleStateChanged}
      disabled={props.disabled}
      value={install_state ?? ''}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      {stateOptions?.sort((t1, t2) => {
        return t1.label < t2.label ? -1 : 1;
      }).map(op => {
        return <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>;
      })}
    </TextField>
  );
};

export default StateSelect;